module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAwIiBoZWlnaHQ9IjIwMCIgdmlld0JveD0iMCAwIDMwMCAyMDAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbC1ydWxlPSJub256ZXJvIiBmaWxsPSJub25lIj48cGF0aCBmaWxsPSIjNDE4OUREIiBkPSJNMCAwaDMwMHYyMDBIMHoiLz48cGF0aCBmaWxsPSIjRkZGIiBkPSJNMTA0LjIwOCA4NS4xMjJsMjguMzAxIDIwLjU2MS0xMC44MSAzMy4yN0wxNTAgMTE4LjM5MWwyOC4zMDEgMjAuNTYyLTEwLjgxLTMzLjI3IDI4LjMwMS0yMC41NjFIMTYwLjgxTDE1MCA1MS44NTJsLTEwLjgxIDMzLjI3eiIvPjwvZz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/svg/flag/cif-so.svg
// module id = 9Vyr
// module chunks = 2